<template>
  <div>
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6" :xxl="4">
          <a-form-item label="订单号">
            <a-input
              v-decorator="['order_no', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入订单号"
              allow-clear
              autocomplete="off"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="申请人">
            <a-input
              v-decorator="['apply_name', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入申请人"
              allow-clear
              autocomplete="off"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="联系电话">
            <a-input
              v-decorator="['phone_number', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入联系电话"
              allow-clear
              autocomplete="off"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="殡仪馆">
            <a-select
              v-decorator="['funeral_home_id']"
              placeholder="请选择殡仪馆"
              @load="loadingHallOptions"
              @focus="fetchFuneralHomeOptions"
              allow-clear
            >
              <a-select-option
                v-for="funeralHome in funeralHomeOptions"
                :key="funeralHome.id"
                :value="funeralHome.id"
              >
                {{ funeralHome.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="厅房">
            <a-select
              v-decorator="['hall_id']"
              placeholder="请选择厅房"
              @load="loadingHallOptions"
              @focus="fetchHallOptions"
              allow-clear
            >
              <a-select-option
                v-for="hall in hallOptions"
                :key="hall.id"
                :value="hall.id"
              >
                {{ hall.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="订单状态">
            <a-select
              placeholder="请选择订单状态"
              v-decorator="['order_status']"
              allow-clear
              @focus="fetchOrderStatusOptions"
            >
              <a-select-option
                v-for="orderStatus in orderStatusList"
                :key="orderStatus.value"
                :value="orderStatus.value"
              >
                {{ orderStatus.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" :xxl="8">
          <a-form-item label="创建时间">
            <a-range-picker v-decorator="['created_at']" />
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="4">
          <a-form-item label="负责人">
            <a-select
              v-decorator="['person_id']"
              placeholder="请选择负责人"
              @focus="fetchUserOptions"
              @load="loadingUserOptions"
              allow-clear
            >
              <a-select-option
                v-for="user in userOptions"
                :key="user.id"
                :value="user.id"
              >
                {{ user.emp_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4" :xxl="4">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findOrderTypeOptions, findOrderStatusOptions } from '@/api/order'
import { findTenantUserOptions } from '@/api/user'
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'
import { findHallOptions } from '@/api/hall'
import { findAllFuneralHomeOptions } from '@/api/funeral_home'

export default {
  name: 'SearchHallFeeDetails',
  data() {
    return {
      orderTypes: [],
      orderStatusList: [],
      userOptions: [],
      hallOptions: [],
      funeralHomeOptions: [],
      loadingUserOptions: false,
      loadingHallOptions: false,
      form: this.$form.createForm(this, { name: 'hall_fee_search' })
    }
  },
  created() {
  },
  methods: {
    fetchFuneralHomeOptions() {
      this.loadingHallOptions = true
      findAllFuneralHomeOptions().then((res) => {
        if (res.code === 0) {
          this.funeralHomeOptions = res.data
        }
        this.loadingHallOptions = false
      })
    },

    fetchHallOptions() {
      this.loadingHallOptions = true
      const fieldsValue = this.form.getFieldsValue()
      if (fieldsValue.funeral_home_id === undefined || fieldsValue.funeral_home_id === 0) {
        this.$warning({
          title: '请先选择殡仪馆！',
          content: ''
        })
      } else {
        findHallOptions({
          funeral_home_id: fieldsValue.funeral_home_id
        }).then((res) => {
          if (res.code === 0) {
            this.hallOptions = res.data
          }
          this.loadingHallOptions = false
        })
      }
    },

    fetchUserOptions() {
      this.loadingUserOptions = true
      findTenantUserOptions().then((res) => {
        if (res.code === 0) {
          this.userOptions = res.data
        }
        this.loadingUserOptions = false
      })
    },
    fetchOrderTypeOptions() {
      findOrderTypeOptions().then((res) => {
        this.orderTypes = res.data
      })
    },
    fetchOrderStatusOptions() {
      findOrderStatusOptions({ order_type: 'service' }).then((res) => {
        this.orderStatusList = res.data
      })
    },
    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
